package org.hs_soft.runmynesto.domain.util.helper

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.snapshotFlow
import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.config.language.StringResources
import org.hs_soft.runmynesto.domain.util.IdUtils

object Strings {

    @Composable
    fun current(): StringResources {
        val currentLanguage = remember { mutableStateOf(LanguageManager.getCurrentStrings()) }

        LaunchedEffect(Unit) {
            snapshotFlow { window.localStorage.getItem(IdUtils.language) }
                .collect { language ->
                    LanguageManager.setLanguage(language)
                    currentLanguage.value = LanguageManager.getCurrentStrings()
                }
        }

        return currentLanguage.value
    }
}